// extracted by mini-css-extract-plugin
export default {"textAreaWrapper":"TextArea_textAreaWrapper__CjTUo","noteAndListWrapper":"TextArea_noteAndListWrapper__GKZ2r"};